import type { AudienceSegmentEntry } from '@openx/types/gqlTypes';

export const checkExportEligibility = (selectedAudienceItems: AudienceSegmentEntry[]): boolean => {
  if (!selectedAudienceItems || selectedAudienceItems.length === 0) {
    return false;
  }

  const allArePredefined = selectedAudienceItems.every(item => item.segment_category === 'predefined');

  const uniqueAccountIds = new Set(selectedAudienceItems.map(item => item.account_id));
  const isSingleDataPartner = uniqueAccountIds.size === 1;

  const allArePublic = selectedAudienceItems.every(item => item.sellable === true);

  // Condition 1: Only OpenXSelect taxonomy segments
  if (allArePredefined) {
    return true;
  }

  // Condition 2: Only segments from single data partner
  if (isSingleDataPartner) {
    return true;
  }

  // Condition 4: Only public Data Marketplace segments
  if (allArePublic) {
    return true;
  }

  // Condition 5: Mix of OpenXSelect + public - each segment is predefined OR sellable
  const allPredefinedOrPublic = selectedAudienceItems.every(
    item => item.segment_category === 'predefined' || item.sellable === true
  );
  if (allPredefinedOrPublic) {
    return true;
  }

  // Condition 3: Mix of OpenXSelect + segments from one data partner
  // All non-predefined segments share same account_id
  const nonPredefinedItems = selectedAudienceItems.filter(item => item.segment_category !== 'predefined');
  const nonPredefinedAccountIds = new Set(nonPredefinedItems.map(item => item.account_id));
  if (nonPredefinedAccountIds.size === 1) {
    return true;
  }

  // Condition 6: Mix of OpenXSelect + public + segments from one data partner
  // For segments that are neither predefined nor sellable, they must share same account_id
  const nonPredefinedNonPublicItems = selectedAudienceItems.filter(
    item => item.segment_category !== 'predefined' && item.sellable !== true
  );
  const nonPredefinedNonPublicAccountIds = new Set(nonPredefinedNonPublicItems.map(item => item.account_id));
  if (nonPredefinedNonPublicAccountIds.size <= 1) {
    return true;
  }

  return false;
};
